<template>
  <b-embed v-if="srcIsDropbox" type="object" aspect="1by1">
    <div ref="dropboxEmbed" />
  </b-embed>
  <b-embed v-else-if="srcIsVimeo" type="iframe" aspect="16by9" :src="vimeoSrc" allowfullscreen>
  </b-embed>
  <b-embed v-else-if="data.type == 'iframe'" type="iframe" aspect="16by9" :src="src" allowfullscreen />
  <b-embed v-else-if="src" class="bg-dark" aspect="16by9" type="video" controls :poster="data.posterSrc"
    :autoplay="autoPlay" :muted="data.muted || muted" :loop="data.loop" playsinline @contextmenu.prevent
    controlsList="nodownload" ref="video">
    <source :src="src" :type="data.type" />
  </b-embed>
  <b-embed v-else />
</template>

<script>
export default {
  name: "OnDemandVideo",
  props: {
    data: { type: Object, required: true },
    autoPlay: Boolean,
    muted: { type: Boolean },
    id: { type: Number, default: undefined }
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.src = this.data.src;
      if (this.srcIsDropbox) {
        this.handleDropboxEmbed();
        return;
      }
      this.trackVideoPlay();
      this.applyVideoStartTime();
    },
    async applyVideoStartTime() {

      await this.$nextTick();

      const video = this.$refs?.video?.childNodes[0];

      if (!video) return;

      const startTime = this.data?.startTime;

      if (!startTime) {
        if (this.canPlayFired) {
          video.currentTime = 0;
        }

        return;
      }

      if (this.canPlayFired) {
        video.currentTime = startTime;
        return;
      }

      let setTime = false;

      video.addEventListener(
        "canplay",
        () => {
          if (setTime) return;
          video.currentTime = startTime;
          setTime = true;
          this.canPlayFired = true;
        },
        { once: true }
      );
    },
    async trackVideoPlay() {
      await this.$nextTick();

      this.$refs?.video?.childNodes[0]?.addEventListener(
        "play",
        () => {
          this.$store.dispatch("logVideoViews", this.data);
        },
        { once: true }
      );
    },
    async handleDropboxEmbed() {
      if (!this.srcIsDropbox) return;
      await this.$nextTick();
      if (this.dbEmbedder) {
        window.Dropbox.unmount(this.dbEmbedder);
      }
      this.dbEmbedder = window.Dropbox.embed({
        link: this.src,
        file: {
          zoom: "best"
        }
      }, this.$refs.dropboxEmbed);
    }
  },
  watch: {
    id() {
      this.load();
    }
  },
  computed: {
    srcIsDropbox() {
      return this.src?.toLowerCase().includes('dropbox');
    },
    srcIsVimeo() {
      return this.src?.toLowerCase().includes('vimeo');
    },
    vimeoSrc() {
      var initSrc = `${this.src}?badge=0&autopause=0&player_id=0&app_id=58479`
      if (!initSrc.includes('player.vimeo.com')) {
        return initSrc.replace('vimeo.com', 'player.vimeo.com/video');
      }
      return initSrc;
    }
  },
  data() {
    return {
      //We store the src inside the component so
      //the video doesn't change out on the user
      //if the underlying data changes
      src: undefined,
      canPlayFired: false,
      dbEmbedder: undefined
    }
  }
};
</script>
